import timesheet from './timesheet/timesheet.reducer';

export const reducers = {
  timesheet
};
